import { GetterTree } from 'vuex';

const getters: GetterTree<Store.StarWars.ProtagonistState, RootState> = {
  protagonistName(state): string {
    const { protagonist } = state;
    return protagonist.name;
  },
};

export default getters;
